module.exports = __webpack_public_path__ + "static/img/serviesbj.00af0bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviesbj.jpg
// module id = FyrZ
// module chunks = 1